// Adapted from Microsoft Elixir-Framework (MIT), v3.0.1164, aa6c10ab1882f8fa20c1da308e6c1fc6fe2fe5e9.
// Source: packages/fx/src/components/Editor/RichText/plugins/readonly/ElxReadOnlyPlugin.ts. Local adaptations: Bug 38755929.
import { CompatiblePluginEventType as PluginEventType } from 'roosterjs';
export class ElxReadOnlyPlugin {
    onPluginEvent(event) {
        var _a;
        if (this.readOnly) {
            if (event.eventType === PluginEventType.KeyDown ||
                event.eventType === PluginEventType.KeyPress ||
                event.eventType === PluginEventType.KeyUp) {
                event.rawEvent.preventDefault();
            }
        }
        if (this.disabled && 'rawEvent' in event) {
            // all event should be prevented when editor is disabled
            (_a = event.rawEvent) === null || _a === void 0 ? void 0 : _a.preventDefault();
        }
    }
    onContextMenu(e) {
        if (this.readOnly || this.disabled) {
            e.preventDefault();
        }
    }
    getName() {
        return 'ElxReadOnlyPlugin';
    }
    setReadOnly(readOnly) {
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.disabled = disabled;
    }
    initialize(editor) {
        this.editor = editor;
    }
    dispose() {
        if (this.editor) {
            this.editor = undefined;
        }
    }
    willHandleEventExclusively() {
        return false;
    }
}
